import {
  Pagination,
} from "@mui/material";
import { withStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import React, { Component } from "react";
import { TooltipCustom } from "../infra/styleGlobal";
import { Text, TextInput, View } from "./index";
import { makeStyles } from '@mui/material/styles';
class Paginador extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1
    }
  }
  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }
  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(undefined)
    }
  }

  setPage(page, callback) {
    this.setState({ page: page }, () => {
      if (callback) return callback();
    })
  }

  onChangePage(page) {
    if (!page) {
      page = 1;
    }
    if (Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage)) < page) {
      page = Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage));
    }

    this.setState({ page: page }, (data, error) => {
      if (this.props.funcLista) {
        this.props.funcLista(page)
      }
    })
  }

  getPage() {
    return this.state.page;
  }


  render() {

    let { classes, count = 0 } = this.props;

    if (!count) {
      return <Text style={{ alignSelf: 'center' }} >Nenhum registro encontrado</Text>
    }
    var maxpag = parseInt(Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage)));

    return (
      <View className={"toColumnMob"} style={styles.view2}>
        <View style={styles.view2}>
          <Pagination
            style={{ marginTop: 10, color:'black' }}
            page={this.state.page} onChange={(eve, val) => {
              this.onChangePage(val)
            }}
            count={maxpag} variant="outlined" shape="rounded" />
          {false && <React.Fragment>
            <IconButton
              onClick={() => {
                this.onChangePage(0);
              }}
              disabled={this.state.page == 1}
              aria-label="first page"
            >
              <FirstPageIcon style={{ color: 'black' }} />
            </IconButton>
            <IconButton

              onClick={() => {
                this.onChangePage(this.state.page - 1);
              }}
              disabled={this.state.page == 1} >
              <KeyboardArrowLeft style={{ color: 'black' }} />
            </IconButton>


            <TextInput
              style={styles.TextField2}
              fullWidth
              inputProps={{ min: 1, max: Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage)), style: { textAlign: 'center' } }}
              value={this.state.page}
              mask={"999"}
              onChange={value => {
                this.onChangePage(value);
              }}
            />


            <Text style={{ marginTop: 5, alignSelf: 'center' }}> {"de " + (maxpag)} </Text>

            <IconButton
              onClick={() => {
                this.onChangePage(this.state.page + 1);
              }}
              disabled={this.state.page >= Math.ceil(this.props.count / this.props.rowsPerPage)}

            >
              <KeyboardArrowRight style={{ color: 'black' }} />
              {/* {this.theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />} */}
            </IconButton>
            <IconButton
              onClick={() => {
                this.onChangePage(Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage)));
              }}
              disabled={this.state.page >= Math.ceil(this.props.count / this.props.rowsPerPage)}
              aria-label="last page"
            >
              <LastPageIcon style={{ color: 'black' }} />
              {/* {this.theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />} */}
            </IconButton>
          </React.Fragment>
          }
          {this.props.showGetTXT &&
            <TooltipCustom
              title={"Baixar todos os dados da tabela em formato de csv (por ;). Nenhuma formatação será aplicada aos campos."}  >
              <IconButton
                onClick={() => {
                  this.props.getTXT();
                }}
              >
                <Text style={{ fontSize: '12' }}>CSV</Text>
                {/* {this.theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />} */}
              </IconButton>
            </TooltipCustom>
          }
        </View>
        <View style={{ justifyContent: 'center', alignSelf: 'center', flexDirection: 'row', width: 100 }}>
          <Text style={{ marginTop: 5, alignSelf: 'center' }}>{"Total: " + this.props.count}</Text>
        </View>
      </View>
    )
  }
}

var styles = {
  view2: {
    heigth: 30,
    width: "100%",
    justifyContent: "center",
    flexDirection: 'row',
    alignSelf: 'center'
  },
  TextField2: {
    width: 40,
    marginTop: 10

  }
};

const styl = theme => ({
  icon: {
    color: "rgba(238,238,238,1)"
  },
  chip: {
    margin: theme.spacing(1),
  },
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
  buttonAdd: {
    right: 0,
    position: "absolute"
  }
});
export default withStyles(styl)(Paginador);
